var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9693 4.19531L10.3573 9.80731C9.73158 10.4315 8.88383 10.782 8 10.782C7.11617 10.782 6.26842 10.4315 5.64267 9.80731L0.0306667 4.19531C0.0213333 4.30065 0 4.39598 0 4.50065V12.5006C0.00105857 13.3844 0.352588 14.2316 0.97748 14.8565C1.60237 15.4814 2.4496 15.8329 3.33333 15.834H12.6667C13.5504 15.8329 14.3976 15.4814 15.0225 14.8565C15.6474 14.2316 15.9989 13.3844 16 12.5006V4.50065C16 4.39598 15.9787 4.30065 15.9693 4.19531Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41476 8.8614L15.5041 2.7714C15.2091 2.28227 14.7931 1.87742 14.2961 1.59588C13.7991 1.31434 13.2379 1.16562 12.6668 1.16406H3.33343C2.76224 1.16562 2.20109 1.31434 1.70411 1.59588C1.20713 1.87742 0.791079 2.28227 0.496094 2.7714L6.58543 8.8614C6.96114 9.23561 7.46982 9.44571 8.00009 9.44571C8.53037 9.44571 9.03905 9.23561 9.41476 8.8614Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.5302f915f93eb786c18f99d5abec1bd5.svg";
export { ForwardRef as ReactComponent };